import authRules from '../authRules.js';

const liveSchedules = (user) => {
  const { scheduleView } = user.securityLevels;
  if (scheduleView >= authRules.liveSchedules.scheduleView) {
      return true;
  } else {
      return false;
    }
  }


export default liveSchedules;
